import { message } from 'antd';

export default () => {
  message.config({
    maxCount: 2,
  });
};
